import React from "react"

import Tags from "../../common/tags/Tags"
import TagItem from "../../common/tags/TagItem"
import BackgroundImage from "../../common/BackgroundImage"
import SourceStatusButton from "../SourceStatusButton"
import { contentTypeLabels } from "../../../config/application-definitions"

const SourceListItem = ({
    id,
    activeId,
    name,
    description,
    type,
    favicon,
    active,
    content_type,
    onClick,
}) => (
    <div
        className={`list-group-item${
            activeId === id ? " active" : ""
        } source-list-item`}
        onClick={onClick ? onClick(id) : null}
    >
        <BackgroundImage
            classList={["list-group-item-thumb"]}
            imageUrl={favicon}
            isThumbnail={true}
        />
        <div className="list-group-item-content">
            <h4>{name}</h4>
            <p className="source-description">{description}</p>
            {active !== null && active !== undefined && (
                <SourceStatusButton active={active} />
            )}
            {(type || content_type) && (
                <Tags>
                    {type && <TagItem isGrey={true}>{type}</TagItem>}
                    {content_type && contentTypeLabels[content_type] && (
                        <TagItem isGrey={true}>
                            {contentTypeLabels[content_type]}
                        </TagItem>
                    )}
                </Tags>
            )}
        </div>
    </div>
)

export default SourceListItem
